import { CommonModule } from '@angular/common';
import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-base-text-area',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './base-text-area.component.html',
  styleUrl: './base-text-area.component.scss',
   providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => BaseTextAreaComponent),
        multi: true
      }
    ]
})
export class BaseTextAreaComponent {
  @Input() placeholder = '';
  @Input() value = '';
  @Input() autocomplete?: string;
  @Input() ariaLabel?: string;
  @Input() maxlength?: number;
  @Input() isFluid: boolean = false;
  @Input() disabled = false;
  @Input() hasIcon = false;
   @Input() height?: string = '96px';
  @Input() mt = '';
  @Input() mb = '';

  @Output() focusEvent = new EventEmitter<FocusEvent>();
  @Output() blurEvent = new EventEmitter<FocusEvent>();
  @Output() valueChange = new EventEmitter<string>();
  @Output() onEnter = new EventEmitter<void>();

  onChange = (_: any) => {};
  onTouched = () => {};

  onInput(event: Event) {
    this.value = (event.target as HTMLInputElement).value;
    this.onChange(this.value);
  }

  handleFocus(event: FocusEvent) {
    this.focusEvent.emit(event);
  }

  handleBlur(event: FocusEvent) {
    this.blurEvent.emit(event);
  }

  handleKeyPress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onEnter.emit();
    }
  }

  // ControlValueAccessor Methods
  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
